import { Dvr, OpenInNew, Troubleshoot, Waves } from "@mui/icons-material";
import { Box, Button, SxProps, Theme } from "@mui/material";
import { Link } from "react-router-dom";
import { createRelatedParams, evaluationFilter } from "./utils";
import { neuroFeebackDataFilter, protocolFilter } from "./utils";
import { NeurofeedbackView, nfbDataFieldsQuery } from "./NeurofeedbackRelated";
import { evaluationsFieldsQuery } from "../../../evaluations/evaluationRoutes";
import { nfbProtocolFieldsQuery } from "../../../protocols/protocolRoutes";
import { UseRecordsOptions } from "../../../../api/useRecords";
import { neurofeedbackSessionsOptions } from "../../../neurofeedback-zscore-sessions/neurofeedbackSessionsOptions";
import { evaluationsOptions } from "../../../evaluations/evaluationsOptions";
import { protocolOptions } from "../../../protocols/protocolOptions";

type ToggleNeurofeedbackItemsProps = {
    setNeurofeedbackView: React.Dispatch<React.SetStateAction<NeurofeedbackView>>;
    neurofeedbackView: NeurofeedbackView;
    style?: SxProps<Theme>;
    treatmentId: string;
    buttonWidth: string;
};

export const ToggleNeurofeedbackItems = ({
    setNeurofeedbackView,
    neurofeedbackView,
    treatmentId,
    buttonWidth,
}: ToggleNeurofeedbackItemsProps) => {
    return (
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexGrow: 1 }}>
            <Box sx={{ display: "flex", flex: 1, gap: 4, alignItems: "center", flexDirection:{xs:"column", sm:"row"} }}>
                <ChangeButton
                    neurofeedbackView={neurofeedbackView}
                    setNeurofeedbackView={setNeurofeedbackView}
                    entity="neurofeedback_data"
                    icon={<Waves />}
                    label="Neurofeedback"
                    filter={neuroFeebackDataFilter}
                    fieldsQuery={nfbDataFieldsQuery}
                    recordsOptions={neurofeedbackSessionsOptions}
                    buttonWidth={buttonWidth}
                />
                <ChangeButton
                    neurofeedbackView={neurofeedbackView}
                    setNeurofeedbackView={setNeurofeedbackView}
                    entity="evaluations"
                    icon={<Troubleshoot />}
                    label="Avaliações"
                    filter={evaluationFilter}
                    fieldsQuery={evaluationsFieldsQuery}
                    relatedParams={""}
                    recordsOptions={evaluationsOptions}
                    buttonWidth={buttonWidth}
                />
                <ChangeButton
                    neurofeedbackView={neurofeedbackView}
                    setNeurofeedbackView={setNeurofeedbackView}
                    entity="protocols"
                    icon={<Dvr />}
                    label="Protocolos"
                    filter={protocolFilter}
                    fieldsQuery={nfbProtocolFieldsQuery}
                    recordsOptions={protocolOptions}
                    buttonWidth={buttonWidth}
                />
            </Box>
            <Box>
                {neurofeedbackView.entity === "protocols" && (
                    <Button component={Link} to={`/protocols/create?${createRelatedParams("protocols", treatmentId)}`}>
                        Criar
                    </Button>
                )}
            </Box>
            <Box>
                {neurofeedbackView.entity === "evaluations" && (
                    <Button
                        endIcon={<OpenInNew />}
                        target="_blank"
                        variant="outlined"
                        color="secondary"
                        component={Link}
                        to={`/eeg_comparison?${createRelatedParams("evaluations", treatmentId)}`}
                    >
                        Comparar EEGs
                    </Button>
                )}
            </Box>
        </Box>
    );
};

type ChangeButtonProps = {
    neurofeedbackView: NeurofeedbackView;
    setNeurofeedbackView: React.Dispatch<React.SetStateAction<NeurofeedbackView>>;
    entity: string;
    icon: React.ReactNode;
    label: string;
    filter: (parentId: string) => any;
    fieldsQuery: string;
    relatedParams?: string;
    recordsOptions?: UseRecordsOptions;
    buttonWidth: string;
};

const ChangeButton = ({
    neurofeedbackView,
    setNeurofeedbackView,
    entity,
    icon,
    label,
    filter,
    fieldsQuery,
    relatedParams,
    recordsOptions,
    buttonWidth,
}: ChangeButtonProps) => {
    return (
        <Button
            variant={neurofeedbackView.entity === entity ? "contained" : "outlined"}
            onClick={() => setNeurofeedbackView({ entity, fieldsQuery, filter, relatedParams, recordsOptions })}
            startIcon={icon}
            color="secondary"
            sx={{ minWidth: { sm: buttonWidth } }}
        >
            {label}
        </Button>
    );
};
